/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { GpsOrigin } from "../../../../gen/body/gps_origin";

export const protobufPackage = "skills";

export interface InitGlobalMapFromGpsArgs {
  globalMapGpsOrigin: GpsOrigin | undefined;
}

export interface InitGlobalMapActionArgs {
  useGps: boolean;
  initFromGpsArgs: InitGlobalMapFromGpsArgs | undefined;
}

export interface InitGlobalMapResultData {
}

export interface InitGlobalMapActionStateData {
}

function createBaseInitGlobalMapFromGpsArgs(): InitGlobalMapFromGpsArgs {
  return { globalMapGpsOrigin: undefined };
}

export const InitGlobalMapFromGpsArgs = {
  encode(message: InitGlobalMapFromGpsArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.globalMapGpsOrigin !== undefined) {
      GpsOrigin.encode(message.globalMapGpsOrigin, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InitGlobalMapFromGpsArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInitGlobalMapFromGpsArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.globalMapGpsOrigin = GpsOrigin.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InitGlobalMapFromGpsArgs {
    return {
      globalMapGpsOrigin: isSet(object.globalMapGpsOrigin) ? GpsOrigin.fromJSON(object.globalMapGpsOrigin) : undefined,
    };
  },

  toJSON(message: InitGlobalMapFromGpsArgs): unknown {
    const obj: any = {};
    if (message.globalMapGpsOrigin !== undefined) {
      obj.globalMapGpsOrigin = GpsOrigin.toJSON(message.globalMapGpsOrigin);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InitGlobalMapFromGpsArgs>, I>>(base?: I): InitGlobalMapFromGpsArgs {
    return InitGlobalMapFromGpsArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InitGlobalMapFromGpsArgs>, I>>(object: I): InitGlobalMapFromGpsArgs {
    const message = createBaseInitGlobalMapFromGpsArgs();
    message.globalMapGpsOrigin = (object.globalMapGpsOrigin !== undefined && object.globalMapGpsOrigin !== null)
      ? GpsOrigin.fromPartial(object.globalMapGpsOrigin)
      : undefined;
    return message;
  },
};

function createBaseInitGlobalMapActionArgs(): InitGlobalMapActionArgs {
  return { useGps: false, initFromGpsArgs: undefined };
}

export const InitGlobalMapActionArgs = {
  encode(message: InitGlobalMapActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.useGps === true) {
      writer.uint32(8).bool(message.useGps);
    }
    if (message.initFromGpsArgs !== undefined) {
      InitGlobalMapFromGpsArgs.encode(message.initFromGpsArgs, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InitGlobalMapActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInitGlobalMapActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.useGps = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.initFromGpsArgs = InitGlobalMapFromGpsArgs.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InitGlobalMapActionArgs {
    return {
      useGps: isSet(object.useGps) ? globalThis.Boolean(object.useGps) : false,
      initFromGpsArgs: isSet(object.initFromGpsArgs)
        ? InitGlobalMapFromGpsArgs.fromJSON(object.initFromGpsArgs)
        : undefined,
    };
  },

  toJSON(message: InitGlobalMapActionArgs): unknown {
    const obj: any = {};
    if (message.useGps === true) {
      obj.useGps = message.useGps;
    }
    if (message.initFromGpsArgs !== undefined) {
      obj.initFromGpsArgs = InitGlobalMapFromGpsArgs.toJSON(message.initFromGpsArgs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InitGlobalMapActionArgs>, I>>(base?: I): InitGlobalMapActionArgs {
    return InitGlobalMapActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InitGlobalMapActionArgs>, I>>(object: I): InitGlobalMapActionArgs {
    const message = createBaseInitGlobalMapActionArgs();
    message.useGps = object.useGps ?? false;
    message.initFromGpsArgs = (object.initFromGpsArgs !== undefined && object.initFromGpsArgs !== null)
      ? InitGlobalMapFromGpsArgs.fromPartial(object.initFromGpsArgs)
      : undefined;
    return message;
  },
};

function createBaseInitGlobalMapResultData(): InitGlobalMapResultData {
  return {};
}

export const InitGlobalMapResultData = {
  encode(_: InitGlobalMapResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InitGlobalMapResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInitGlobalMapResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): InitGlobalMapResultData {
    return {};
  },

  toJSON(_: InitGlobalMapResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<InitGlobalMapResultData>, I>>(base?: I): InitGlobalMapResultData {
    return InitGlobalMapResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InitGlobalMapResultData>, I>>(_: I): InitGlobalMapResultData {
    const message = createBaseInitGlobalMapResultData();
    return message;
  },
};

function createBaseInitGlobalMapActionStateData(): InitGlobalMapActionStateData {
  return {};
}

export const InitGlobalMapActionStateData = {
  encode(_: InitGlobalMapActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InitGlobalMapActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInitGlobalMapActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): InitGlobalMapActionStateData {
    return {};
  },

  toJSON(_: InitGlobalMapActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<InitGlobalMapActionStateData>, I>>(base?: I): InitGlobalMapActionStateData {
    return InitGlobalMapActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InitGlobalMapActionStateData>, I>>(_: I): InitGlobalMapActionStateData {
    const message = createBaseInitGlobalMapActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
